import { ReactElement, ReactNode } from 'react'
import FilterAlt from '@mui/icons-material/FilterAlt'
import { Button, ButtonProps } from '@mui/material'

interface Props extends ButtonProps {
  children?: ReactNode
}

const FilterButton = ({
  children = 'filtern',
  variant = 'outlined',
  ...props
}: Props): ReactElement => (
  <Button variant={variant} startIcon={<FilterAlt />} {...props}>
    {children}
  </Button>
)

export default FilterButton
